// ViewTypeIcons.js

export const DEFAULT_VIEW_TYPE_ICON_KEY = Object.freeze({
  TABLE: 'table',
  BOARD: 'view_kanban',
  GALLERY: 'gallery_thumbnail',
  LIST: 'format_list_bulleted',
  FEED: 'dynamic_feed',
  CALENDAR: 'calendar_month',
  TIMELINE: 'view_timeline',
  SCHEDULER: 'calendar_view_day',
  MAP: 'map',
  CHART: 'bar_chart',
  FORM: 'dynamic_form',
});

export const CALENDAR_VIEW_TYPE_ICON_KEY = Object.freeze({
  MONTH: 'calendar_view_month',
  WEEK: 'calendar_view_week',
  THREEDAY: 'view_week',
  DAY: 'calendar_view_day',
  AGENDA: 'view_agenda',
});

export const TIMELINE_VIEW_TYPE_ICON_KEY = Object.freeze({
  DAY: 'view_agenda',
  WEEK: 'view_agenda',
  MONTH: 'view_agenda',
  QUARTER: 'view_agenda',
  YEAR: 'view_agenda',
});

export function getViewTypeIconKey(type, map, fallback = null) {
  const normalizedType = String(type || '').trim().toUpperCase();
  if (!normalizedType) return fallback;
  return map?.[normalizedType] || fallback;
}

export function getDefaultViewTypeIconKey(type, fallback = null) {
  return getViewTypeIconKey(type, DEFAULT_VIEW_TYPE_ICON_KEY, fallback);
}

export function getCalendarViewTypeIconKey(type, fallback = null) {
  return getViewTypeIconKey(type, CALENDAR_VIEW_TYPE_ICON_KEY, fallback);
}

export function getTimelineViewTypeIconKey(type, fallback = null) {
  return getViewTypeIconKey(type, TIMELINE_VIEW_TYPE_ICON_KEY, fallback);
}
